/**
 * Botões de OAuth Google + GitHub.
 *
 * Em MVP local, o backend ainda não tem credenciais OAuth configuradas
 * por padrão (vars OAUTH_*_CLIENT_ID/SECRET vazias no .env.example).
 * Mostramos os botões como "em breve" — quando o user configurar as vars,
 * basta a API expor um endpoint /api/v1/auth/oauth/options que indica
 * habilitação e este componente passa a chamar /auth/oauth/:provider/start.
 *
 * Por enquanto, presença visual indica para onde a app está indo.
 */
export function OAuthButtons() {
  return (
    <div>
      <div className="flex items-center gap-3">
        <span className="h-px flex-1 bg-[var(--border-subtle)]" />
        <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--ink-tertiary)]">
          ou
        </span>
        <span className="h-px flex-1 bg-[var(--border-subtle)]" />
      </div>
      <div className="mt-4 grid gap-2">
        <OAuthButton provider="google" disabled label="Continuar com Google" />
        <OAuthButton provider="github" disabled label="Continuar com GitHub" />
      </div>
      <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--ink-muted)]">
        oauth · em breve
      </p>
    </div>
  );
}

function OAuthButton({
  provider,
  disabled,
  label,
}: {
  provider: 'google' | 'github';
  disabled: boolean;
  label: string;
}) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => {
        if (!disabled) {
          window.location.href = `/api/v1/auth/oauth/${provider}/start`;
        }
      }}
      className="flex items-center justify-center gap-2 rounded-sm border border-[var(--border-default)] bg-[var(--bg-paper-elevated)] px-4 py-2 font-sans text-sm text-[var(--ink-secondary)] transition-opacity hover:border-[var(--border-strong)] disabled:opacity-50"
    >
      <ProviderIcon provider={provider} />
      {label}
    </button>
  );
}

function ProviderIcon({ provider }: { provider: 'google' | 'github' }) {
  if (provider === 'google') {
    return (
      <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden>
        <path
          d="M15.68 8.18c0-.5-.04-1-.13-1.45H8v2.74h4.31c-.18.94-.74 1.74-1.58 2.27v1.88h2.55c1.5-1.38 2.4-3.4 2.4-5.44z"
          fill="currentColor"
          opacity="0.6"
        />
        <path
          d="M8 16c2.16 0 3.97-.71 5.28-1.93l-2.55-1.98c-.71.48-1.62.76-2.73.76-2.1 0-3.88-1.42-4.51-3.32H.85v2.04C2.15 14.16 4.86 16 8 16z"
          fill="currentColor"
          opacity="0.45"
        />
        <path
          d="M3.49 9.53c-.16-.48-.25-.99-.25-1.53s.09-1.05.25-1.53V4.43H.85C.31 5.5 0 6.71 0 8s.31 2.5.85 3.57l2.64-2.04z"
          fill="currentColor"
          opacity="0.3"
        />
        <path
          d="M8 3.18c1.18 0 2.24.4 3.07 1.2l2.27-2.27C11.96.79 10.16 0 8 0 4.86 0 2.15 1.84.85 4.43l2.64 2.04C4.12 4.6 5.9 3.18 8 3.18z"
          fill="currentColor"
          opacity="0.75"
        />
      </svg>
    );
  }
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden fill="currentColor">
      <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
    </svg>
  );
}
